import { TicketClassCategory } from '../../constants';
import { CheckoutState } from '../../state';

const hasSomeAddonSelected = (tickets: Array<any>): boolean =>
    tickets.some(
        (ticket) =>
            ticket.category === TicketClassCategory.addOn &&
            ticket.selectedQuantity > 0,
    );

const hasSomeNotAddonSelected = (tickets: Array<any>): boolean =>
    tickets.some(
        (ticket) =>
            ticket.category !== TicketClassCategory.addOn &&
            ticket.selectedQuantity > 0,
    );

export const hasOnlyAddOnsSelected = (state: CheckoutState): boolean => {
    const {
        tickets: { ticketsById },
    } = state;
    const tickets = Object.values(ticketsById);

    // If there is a ticket selected that it is not an addon
    // there are  NOT ONLY addons selected
    if (hasSomeNotAddonSelected(tickets)) {
        return false;
    }

    // If there is a variant selected that it is not an addon
    // there are  NOT ONLY addons selected
    if (
        tickets.some(
            (ticket) =>
                ticket.variants &&
                hasSomeNotAddonSelected(Object.values(ticket.variants)),
        )
    ) {
        return false;
    }

    const hasAddOnSelected = hasSomeAddonSelected(tickets);

    const hasVariantAddonSelected = tickets.some(
        (ticket) =>
            ticket.variants &&
            hasSomeAddonSelected(Object.values(ticket.variants)),
    );

    // At least one ticket or variant with addon type must be selected
    return hasAddOnSelected || hasVariantAddonSelected;
};
